import React from 'react'
import {useTranslation} from 'react-i18next'

import downloadIcon from 'assets/download-yellow.svg'

import Spinner from 'features/common/components/Spinner'
import useQRCards from '../../../../common/hooks/useQRCard/useQRCard'

const QRTabletop = () => {
    const {t} = useTranslation()
    const {data, onDownloadTabletop, isLoading} = useQRCards()

    if (isLoading) {
        return <Spinner yellow className="h-20 w-20 self-center" />
    }

    if (!data) {
        return <div>-</div>
    }

    return (
        <div className="grid grid-cols-2 gap-2">
            <div className="mr-auto">
                <div className="mb-4 text-xl font-bold">{t('QR_TABLETOP')}</div>
                <div className="whitespace-pre-line">
                    {t('QR_TABLETOP_SIZE')}
                </div>
            </div>
            <div className="flex gap-10">
                <div>
                    <img
                        className="rounded-3xl md:w-28 lg:w-32 xl:w-56"
                        src={data.tabletop}
                        alt="qr"
                    />
                </div>
                <div className="ml-auto shrink-0">
                    <button onClick={onDownloadTabletop}>
                        <img src={downloadIcon} alt="download" />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default QRTabletop
